import { render } from "./game-iframe.html?vue&type=template&id=833eb5b6&scoped=true&ts=true"
import script from "./game-iframe.vue?vue&type=script&lang=ts"
export * from "./game-iframe.vue?vue&type=script&lang=ts"

import "./game-iframe.scss?vue&type=style&index=0&id=833eb5b6&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833eb5b6"]])

export default __exports__